const CurrentUser = {
  _user: null,
  getUser() {
    return this._user;
  },
  setUser(usr) {
    this._user = {
      ...usr,
    };
  },
};
export default CurrentUser;
